let productMobileSwiper = null;

function initProductMobileSwiper() {
  productMobileSwiper = new Swiper(".product-mobile-swiper", {
    loop: true,
    autoHeight: true,
    observer: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
}

function destroyProductMobileSwiper() {
  productMobileSwiper.destroy();
}
initProductMobileSwiper();

function initProductDesktopGallery() {
  const nodeImages = document.querySelectorAll(
    ".product-desktop-gallery .product-large-image"
  );

  const nodeImagesMenu = [
    ...document.querySelectorAll(
      ".product-desktop-gallery .product-small-image"
    ),
  ];

  if (nodeImages.length === 0) return;
  if (nodeImagesMenu.length === 0) return;

  let prevYPosition = 0;
  let direction = "up";

  const options = {
    threshold: 0.3,
  };

  const getTargetSection = (entry) => {
    const index = nodeImages.findIndex((section) => section == entry.target);
    if (index >= nodeImages.length - 1) {
      return entry.target;
    } else {
      return nodeImages[index + 1];
    }
  };

  const shouldUpdate = (entry) => {
    if (direction === "down" && !entry.isIntersecting) {
      return true;
    }
    if (direction === "up" && entry.isIntersecting) {
      return true;
    }
    return false;
  };

  const updateMarker = (target) => {
    const id = target.id;
    if (!id) return;

    nodeImagesMenu.forEach((el) => {
      el.classList.remove("active");
    });

    let link = nodeImagesMenu.find((el) => {
      return el.getAttribute("href") === `#${id}`;
    });

    link = link || nodeImagesMenu[0];
    link.classList.add("active");
  };

  const onIntersect = (entries, observer) => {
    entries.forEach((entry) => {
      if (document.body.scrollTop > prevYPosition) {
        direction = "down";
      } else {
        direction = "up";
      }

      prevYPosition = document.body.scrollTop;
      const target =
        direction === "down" ? getTargetSection(entry) : entry.target;

      if (shouldUpdate(entry)) {
        updateMarker(target);
      }
    });
  };

  updateMarker(nodeImages[0]);

  const observer = new IntersectionObserver(onIntersect, options);

  nodeImages.forEach((section) => {
    observer.observe(section);
  });
}
initProductDesktopGallery();

function initProductGalleryYoutube() {
  let liteYoutubeDivsMobile = document.querySelectorAll(
    ".product-mobile-swiper .lite-youtube"
  );
  liteYoutubeDivsMobile.forEach((video) => {
    new LiteYTEmbedDiv(video);
  });
  let liteYoutubeDivsDesktop = document.querySelectorAll(
    ".product-desktop-gallery .lite-youtube"
  );
  liteYoutubeDivsDesktop.forEach((video) => {
    new LiteYTEmbedDiv(video);
  });
}

//product zoom
function initProductGalleryZoom(selector) {
  const icons = document.querySelectorAll(selector);
  if (!icons.length) return;

  const iconsArray = Array.from(icons);

  function buildImagesItems() {
    let images = iconsArray.map((item) => {
      return {
        src: item.getAttribute("href"),
        msrc: item.dataset.msrc,
        w: item.dataset.w,
        h: item.dataset.h,
      };
    });
    return images;
  }

  const options = {
    maxSpreadZoom: 2,
    loop: false,
    allowPanToNext: false,
    closeOnScroll: false,
    showHideOpacity: false,
    arrowKeys: true,
    history: false,
    fullscreenEl: false,
    zoomEl: false,
    shareEl: false,
    counterEl: true,
    arrowEl: true,
    preloaderEl: true,
  };

  function open(e, index) {
    options.index = parseInt(index, 10);

    if (typeof PhotoSwipe !== "undefined") {
      let pswp = new PhotoSwipe(
        (pswpElement = document.querySelectorAll(".pswp")[0]),
        PhotoSwipeUI_Default,
        buildImagesItems(),
        options
      );

      pswp.listen("firstUpdate", () => {
        pswp.listen("parseVerticalMargin", function (item) {
          item.vGap = {
            top: 50,
            bottom: 50,
          };
        });
      });
      pswp.init();
    }
    e.preventDefault();
  }

  icons.forEach(function (link, index) {
    link.addEventListener("click", (e) => open(e, index));
  });
}

initProductGalleryZoom(".product-media-zoom-desktop");
initProductGalleryZoom(".product-media-zoom-swiper");
